<template>
  <div class="cookie-policy" v-if="show">
    <div class="cookie-policy__inner">
      <div v-html="messageText"></div>
      <div class="cookie-policy__actions">
        <button class="cookie-policy__action cookie-policy__action--white" v-on:click="decline">{{ declineLabel }}</button>
        <button class="cookie-policy__action" v-on:click="accept">{{ acceptLabel }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["messageText", "acceptLabel", "declineLabel"],
  data() {
    return {
      show: true,
    };
  },
  methods: {
    accept: function () {
      this.setCookie("cookies-accepted", true);
      this.setCookie("cookies-nonessential", true);
      this.show = false;
    },
    decline: function () {
      this.setCookie("cookies-accepted", false);
      this.setCookie("cookies-nonessential", false);
      this.show = false;
    },
    setCookie: function (name, value) {
      var expires = "";
      var date = new Date();
      date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
      document.cookie = name + "=" + value + expires + "; path=/";
    },
  },
};
</script>
